var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.sections)?_c('div',{staticClass:"checkout-vue-form",attrs:{"id":"checkoutVue"}},_vm._l((_vm.sections),function(section,i){return _c(section.component,{key:section.key,tag:"section",attrs:{"number":i - _vm.number}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }